module.exports = __webpack_public_path__ + "img/healthy_food_logos.f92aead2.svg";